export default {
  en: {
    title: 'Dashboard',
    emergingThreat: {
      title: 'New Emerging Threat - {name}',
      text: "We've added {name} to Risk Ledger so that you may assess the risk of {name} in your supply chain. Your suppliers will now begin adding information about their response to this threat, available to you in your Emerging Threat dashboard.",
      cta: 'View dashboard',
    },
    metricCard: {
      error: 'Unable to load metric',
      showBreakdown: 'Show breakdown',
    },
    metricRow: {
      view: 'View',
    },
    metrics: {
      averageCompliance: 'Average compliance',
      suppliersAwaitingReview: 'Suppliers awaiting review',
      totalSuppliers: 'Total suppliers',
      pendingInvitesRequests: 'Pending invites & requests',
      pendingRemediations: 'Pending remediations',
      incompleteAssessments: 'Incomplete assessments',
      openRisks: 'Open risks',
      discussionResponses:
        '<b>{n} discussion</b> is currently active | <b>{n} discussions</b> are currently active',
      remediationResponses:
        '<b>{n} remediation response</b> is awaiting your review | <b>{n} remediation responses</b> are awaiting your review',
      suppliersNoPoliciesApplied:
        '<b>{n} supplier</b> has no policies applied | <b>{n} suppliers</b> have no policies applied',
      recentlyExpiredInvites:
        '<b>{n} invite</b> recently expired without being accepted | <b>{n} invites</b> recently expired without being accepted',
      pendingReceivedConnectionRequests:
        '<b>{n} connection request</b> from a supplier is pending your response | <b>{n} connection requests</b> from your suppliers are pending a response',
      suppliersDueReReview:
        '<b>{n} supplier</b> is due a re-review | <b>{n} suppliers</b> are due a re-review',
      reviewsExpiringSoon:
        '<b>{n} review</b> will be expiring soon | <b>{n} reviews</b> will be expiring soon',
    },
    delta: {
      positive: '+{n}',
      negative: '{n}',
      noChange: 'No change',
      thirtyDays: 'in the last {n} days',
    },
    breakdowns: {
      suppliersAwaitingReview: {
        not_reviewed: 'Not reviewed',
        in_review: 'In review',
        reviewed: 'Reviewed',
        needs_re_review: 'Needs re-review',
      },
      pendingInvitesRequests: {
        pendingInvites: 'Pending invites',
        pendingSentConnectionRequests: 'Pending sent connection requests',
      },
      pendingRemediations: {
        pendingClientReview: 'Pending your review',
        pendingSupplierRemediation: 'Pending supplier remediation',
      },
      criticality: {
        unknown: 'Unknown',
        minor: 'Minor',
        critical: 'Critical',
        important: 'Important',
      },
      openRisks: {
        open: 'Open',
        closed: 'Closed',
      },
    },
    buttons: {
      add: 'Add',
    },
  },
};
